import { reactive } from 'vue'

const secondMs = 1000;
const minuteMs = secondMs * 60;
const hourMs = minuteMs * 60;
const dayMs = hourMs * 24;

// EXPORT
export const time = reactive({

    getTimeDiff(timeA, timeB) {
        const dateTimeA = new Date(timeA);
        const dateTimeB = new Date(timeB);

        return dateTimeB - dateTimeA;
    },

    /**
     * Checks if "now" is between 2 other times
     */
    isBetweenTimes(firstTime, secondTime) {
        const now = new Date();
        const timeA = new Date(firstTime);
        const timeB = new Date(secondTime);

        if((timeA - now <= 0) && (timeB - now > 0)) {
            return true;
        }

        return false;
    },

    /**
     * Generates display text for countdown based on time units.
     * Acceptable time units: days, hours, minutes, seconds.
     */
    getCountDownDisplayText(slotData, timeUnits=[], autoPlural=true) {
        const vm = this;

        if(timeUnits.length > 0) {
            // INIT
            let displayText = '';

            // LOOP THROUGH TIME UNITS
            timeUnits.forEach((item) => {
                switch(item) {
                    case 'days':
                        displayText += vm.buildCountDownText(slotData[item], 'Day', autoPlural);
                        break;

                    case 'hours':
                        displayText += vm.buildCountDownText(slotData[item], 'Hour', autoPlural);
                        break;

                    case 'minutes':
                        displayText += vm.buildCountDownText(slotData[item], 'Minute', autoPlural);
                        break;

                    case 'seconds':
                        displayText += vm.buildCountDownText(slotData[item], 'Seconds', false);
                        break;
                }
            });

            return displayText.trim();
        }
        else {
            return false;
        }
    },

    buildCountDownText(timeUnit, timeUnitLabel, autoPlural=true) {
        let displayText = '<span class="cfm_ec_countdown_time_unit">' + timeUnit + ' ' + timeUnitLabel;
        if(autoPlural) {
            if(timeUnit > 1) { displayText += 's '}
        }
        else {
            displayText += ' ';
        }

        displayText += '</span>';

        return displayText;
    },

    calcTimeClass(timeDiffMs) {
        let diffClass = '';
        
        switch(true) {
            case (timeDiffMs > dayMs):
                // console.log('timeDiffMs is greater than 1 day.');
                diffClass = 'gt1d';
                break;

            case (timeDiffMs <= dayMs && timeDiffMs > hourMs):
                // console.log('timeDiffMs less than 1 day but greater than 1 hour.');
                diffClass = 'lt1d_gt1h';
                break;

            case (timeDiffMs <= hourMs && timeDiffMs >= minuteMs):
                // console.log('timeDiffMs is less than 1 hour but greater than 1 minute.');
                diffClass = 'lt1h_gt1m';
                break;

            case (timeDiffMs < minuteMs && timeDiffMs > 0):
                // console.log('timeDiffMs is less than 1 minute but greater than 0.');
                diffClass = 'lt1m_gt0s';
                break;

            default:
                // console.log('timeDiffMs has expired (is equal to or less than zero)');
                break;
        }

        return diffClass;
    }
});